import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Bell, Check, ArrowLeft } from "lucide-react";

export default function Notifications() {
  const nav = useNavigate();
  const [notes, setNotes] = useState([]);
  const [unread, setUnread] = useState(0);
  const [busyId, setBusyId] = useState(null);

  const load = () => api.get("/notifications").then(r => { setNotes(r.data.notifications || []); setUnread(r.data.unread_count || 0); }).catch(() => {});
  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  // Click handler: mark read on server, optimistically update UI, then navigate if a link exists
  const openNotif = async (n) => {
    if (busyId) return;
    setBusyId(n.id);
    // Optimistic
    setNotes(list => list.map(x => x.id === n.id ? { ...x, read: true } : x));
    setUnread(u => Math.max(0, u - (n.read ? 0 : 1)));
    try { await api.post(`/notifications/${n.id}/read`); } catch { /* ignore */ }
    setBusyId(null);
    const target = (n.link && n.link !== "#") ? n.link : null;
    if (target) nav(target);
  };

  return (
    <div className="px-4 py-6 pb-24" data-testid="notifications-page">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Link to="/" data-testid="notifications-back" className="p-2 rounded-full bg-white/5 active:scale-90"><ArrowLeft className="w-4 h-4"/></Link>
          <Bell className="w-6 h-6 text-[#00E5FF]"/>
          <h1 className="font-outfit font-extrabold text-2xl tracking-tighter">Notifications</h1>
          {unread > 0 && <span className="px-2 py-0.5 rounded-full bg-[#FF2A5F] text-[10px] font-bold">{unread}</span>}
        </div>
        {unread > 0 && (
          <button onClick={markAll} data-testid="mark-all-read" className="text-xs text-[#00E5FF] flex items-center gap-1"><Check className="w-3.5 h-3.5"/>Read all</button>
        )}
      </div>

      {notes.length === 0 ? (
        <div className="text-center py-16 text-white/50" data-testid="notifications-empty">
          <Bell className="w-12 h-12 mx-auto mb-2 opacity-50"/>
          <p>No notifications yet</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="notifications-list">
          {notes.map(n => (
            <button key={n.id} onClick={() => openNotif(n)} data-testid={`notif-${n.id}`}
              disabled={busyId === n.id}
              className={`w-full flex items-start gap-3 p-3 rounded-2xl border text-left active:scale-[0.99] transition ${n.read ? "bg-white/5 border-white/10" : "bg-[#00E5FF]/5 border-[#00E5FF]/20"}`}>
              <div className="text-2xl flex-shrink-0">{n.icon || "🔔"}</div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-base">{n.title}</div>
                {n.body && <div className="text-sm text-white/75 mt-1 whitespace-pre-line leading-relaxed">{n.body}</div>}
                <div className="text-[10px] text-white/40 mt-1">{new Date(n.created_at).toLocaleString()}</div>
              </div>
              {!n.read && <div className="w-2 h-2 rounded-full bg-[#00E5FF] flex-shrink-0 mt-1"/>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
